import { createContext, useContext, useState } from "react";

const FormBuilderContext = createContext<any>(null);

export const useFormBuilder = () => {
  const context = useContext(FormBuilderContext);

  if (!context) {
    return {
      formData: null,
      setFormData: () => {},
      existingFormfromContext: false,
      setExistingFormfromContext: () => {},
    };
  }

  return context;
};

export const FormBuilderProvider = ({ children }: any) => {
  const [formData, setFormData] = useState<any>({
    templateMetadata: {
      templateImage: "",
      fields: [],
    },
  });

  const [existingFormfromContext, setExistingFormfromContext] = useState(false);
   

  return (
    <FormBuilderContext.Provider
      value={{
        formData,
        setFormData,
        existingFormfromContext,
        setExistingFormfromContext,
      }}
    >
      {children}
    </FormBuilderContext.Provider>
  );
};